import { render } from "./verificarCorreo.vue?vue&type=template&id=1a260174"
import script from "./verificarCorreo.vue?vue&type=script&lang=js"
export * from "./verificarCorreo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__